// @ts-nocheck
import { getCountriesWebsites } from "@store/Framework/Services/GetCountriesWebsites";
import { CountryWebsiteModel } from "@store/Framework/Types/CountryWebsiteModel";
import { useEffect, useState } from "react";

export const useCountriesWebsites = (): { countriesWebsite: CountryWebsiteModel[]; currentCountryWebsite: string } => {
    const [countriesWebsite, setCountriesWebsite] = useState<CountryWebsiteModel[]>([]);
    const [currentCountryWebsite, setCurrentCountryWebsite] = useState("");

    useEffect(() => {
        getCountriesWebsites()
            .then((countriesWebsite: CountryWebsiteModel[]) => {
                setCountriesWebsite(countriesWebsite);

                const currentUrl = window.location.href;
                const currentCountry = countriesWebsite.find(country => currentUrl.includes(country.url));

                if (currentCountry) {
                    setCurrentCountryWebsite(currentCountry.name);
                }
            })
            // eslint-disable-next-line no-console
            .catch(error => console.error(error));
    }, []);

    return { countriesWebsite, currentCountryWebsite };
};
